export default "/assets/tonlabs.png";